export const FILTER_NAME = 'brand'
